// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c439e432","453":"4bd2d501","455":"0f1a1367"}[chunkId] + ".chunk.js";
};